import {toValue, watchDebounced} from "@vueuse/core";
import type {MaybeRefOrGetter} from "@vueuse/core";
import {getCalendarCruiseList} from "~/services/product";
import useRequest from "../useRequest";
import type {GetCalendarCruiseListParam} from "~/services/model/calendar";
import {useRouteQuery} from "@/composables/router";
import {toNumber} from "~/utils/helpers";

export function useCruiseCalendarCruiseList(
    param: MaybeRefOrGetter<GetCalendarCruiseListParam>
) {
    const pageIndex = useRouteQuery("p", "1", {
        transform: toNumber,
    });
    const sortType = useRouteQuery<"asc" | "desc">("st", "asc");
    const sortName = useRouteQuery<string>("sn", "2");

    const {state, execute, isReady} = useRequest(
        () => getCalendarCruiseList({
            ...toValue(param),
            sort_name: toValue(sortName),
            sort_type: toValue(sortType) === "asc" ? "4" : "3",
            page_size: 10,
            page_index: toValue(pageIndex),
        }),
        {
            list: [],
            top_list: [],
            page_count: 1,
            page_index: 1,
            page_size: 10,
            total_count: 1,
            total_page: 1,
        },
        {
            immediate: false,
            resetOnExecute: false,
        }
    );

    const onPageChange = (page: number) => {
        pageIndex.value = page;
    };


    return {state, execute, isReady, pageIndex, sortType, sortName, onPageChange};
}
